import { Admin, Therapist } from '_api/types';

import useGetQuery from '../useGetQuery';

export const CHECK_LOGIN_KEY = 'check-login';

export const useCheckLogin = () => {
  return useGetQuery<Admin | Therapist>(() => '/auth/me', {}, [CHECK_LOGIN_KEY], {
    refetchOnWindowFocus: false,
  });
};
